export default {
  'challengeManager.altMethodMessage': 'Send to <%=altMethod %> via <%=altMethodType %>',
  'challengeManager.altWay': 'Need to receive code another way?',
  'challengeManager.enterCode': 'Enter code',
  'challengeManager.primaryMethodMessage':
    'A one-time passcode was sent to <%=primaryMethod %> via <%=primaryMethodType %>.',
  'challengeManager.resendCode': 'Send new code',
  'challengeManager.title': 'User Verification',
  'challengeManager.rememberDevice': 'Remember this device',
  'challengeManager.passcodeOtherWay':
    'A one-time passcode was sent to <%=maskedAltMethodVal %> via <%=altMethodType %>.',
  'challengeManager.enterPinTokenCode': 'Please enter the current PIN + token code',
  'challengeManager.enterTokenCode': 'Please enter the current token code',
  'challengeManager.nextTokenCode': 'and the next token code',
  'challengeManager.pinTokenCode': 'PIN + token code',
  'challengeManager.radiusUnavailable':
    'Unable to process your request. Please contact your administrator.',
  'challengeManager.vipUnavailable':
    'Unable to process your request. Please contact your administrator.',
  'challengeManager.labelTokencode': 'Token code',
  'challengeManager.labelNextTokencode': 'Next token code',
  'challengeManager.invalidCode':
    'Invalid Code. <%=numberOfFailedAttempts %> failed attempt(s). <%=numberOfAttemptsAllowed %> attempt(s) allowed.'
};
